"use client"

import React, { useCallback } from 'react'
import { Box } from "@mui/material"
import { Logout, Settings, Person } from "@mui/icons-material"
import GlobalLogicLogo from "../GlobalLogicLogo"
import UserProfile from "../UserProfile/UserProfile"

import type { MenuOption } from "../UserProfile/types"
import { useAuth } from '../../../context/AuthContext'

const Header: React.FC = () => {

    const { logout, getUserName,
        getUserSurname,
    } = useAuth(); // Extraer user del contexto

    const handleProfileClick = useCallback(() => {
    }, [])

    const handleSettingsClick = useCallback(() => {
    }, [])

    const handleLogoutClick = useCallback(() => {
        logout()
    }, [logout])

    const menuOptions: MenuOption[] = [
        {
            label: 'Profile',
            icon: <Person />,
            onClick: handleProfileClick
        },
        {
            label: 'Settings',
            icon: <Settings />,
            onClick: handleSettingsClick
        },
        {
            label: 'Logout',
            icon: <Logout />,
            onClick: handleLogoutClick
        }
    ]

    const userName = getUserName() || "Guest";
    const userSurname = getUserSurname() || "";
    const fullName = `${userName} ${userSurname}`.trim();
    const initials = fullName
        ? fullName
            .split(" ")
            .map((word: string) => word[0])
            .join("")
            .toUpperCase()
        : "NA";

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                bgcolor: "white",
                borderBottom: "1px solid #E8E8E8",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <GlobalLogicLogo />
            </Box>

            <UserProfile
                name={fullName}
                role="System Admin"
                initials={initials}
                menuOptions={menuOptions}
            />
        </Box>
    )
}

export default Header
